import { CalendarIcon } from '@WebComponents/svgs/icons/CalendarIcon';
import { css } from 'aphrodite';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { styleSheet } from '../../styles';
import { MEETING_PREP_TELEMETRY_CATEGORY } from './DashboardMeetingPrepRow';

export const DashboardMeetingPrepPausedRow: FC = () => {
	const history = useHistory();
	const { logEvent } = useEventLogging(MEETING_PREP_TELEMETRY_CATEGORY);

	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<CalendarIcon />
				</AgentRowIcon>
			}
			title={
				<>
					Delivery is paused
					<span className={css(styleSheet.rowTitleMeta)}>Meeting Prep Assistant</span>
				</>
			}
			detail='You won’t get meeting briefs until it’s back on.'
			action={
				<Button
					size='sm'
					variant='secondary'
					onClick={() => {
						logEvent('SettingsClicked', { from: 'pausedRow' });
						history.push(ROUTES.meetingPrep.settings);
					}}
				>
					Settings
				</Button>
			}
		/>
	);
};
